import React, {useEffect, useState} from 'react';
import Menu from '../../Menu';
import PageHeader from '../../PageHeader';
import LessonCard from '../LessonCard';
import {LearningCategory, LearningLesson, learningCount, loadLearningOverview} from '../learning';
import '../Learning.scss';

type Filter = 'all' | 'in_progress' | 'passed';

export function KnowledgeBase1({idCategory}: {idCategory: string | number}) {
    const [category, setCategory] = useState<LearningCategory | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [filter, setFilter] = useState<Filter>('all');
    const [reload, setReload] = useState(0);

    useEffect(() => {
        let active = true;
        setLoading(true);
        setError('');
        loadLearningOverview().then(data => {
            if (!active) return;
            setCategory(data.categories.find(item => item.id === Number(idCategory)) || null);
            setLoading(false);
        }).catch(() => {
            if (!active) return;
            setError('Не удалось загрузить уроки. Попробуйте ещё раз.');
            setLoading(false);
        });
        return () => { active = false; };
    }, [idCategory, reload]);

    const visibleLessons = (category?.lessons || []).filter((lesson: LearningLesson) => {
        if (filter === 'passed') return lesson.status === 'passed';
        if (filter === 'in_progress') return ['opened', 'in_progress', 'retry'].includes(lesson.status);
        return true;
    });

    return <div className='main learning-page'>
        <div className='content mx-w-content'>
            <PageHeader pageTitle='Уроки' backBtnUrl='/knowledge-base'/>
            <div className='pt-header'/>
            <div className='learning-container'>
                {loading && <div className='learning-state' role='status'>Загружаем уроки…</div>}
                {error && <div className='learning-state is-error' role='alert'>{error}<button type='button' onClick={() => setReload(value => value + 1)}>Повторить</button></div>}
                {!loading && !error && !category && <div className='learning-empty'>Категория не найдена или в ней пока нет уроков.</div>}
                {!loading && !error && category && <>
                    <div className='learning-category-head'>
                        <span className='learning-eyebrow'>Категория обучения</span>
                        <h2>{category.title}</h2>
                        <p>{learningCount(category.lessonCount, 'урок', 'урока', 'уроков')}{category.testCount > 0 ? ` · ${category.passedCount} из ${category.testCount} тестов пройдено` : ''}</p>
                        {category.testCount > 0 && <div className='learning-progress-track' role='progressbar' aria-valuenow={category.passedCount} aria-valuemin={0} aria-valuemax={category.testCount} aria-label='Пройдено тестов в категории'>
                            <span style={{width: `${Math.round(category.passedCount / category.testCount * 100)}%`}}/>
                        </div>}
                    </div>
                    <div className='learning-tabs' role='group' aria-label='Фильтр уроков'>
                        <button type='button' aria-pressed={filter === 'all'} className={filter === 'all' ? 'is-active' : ''} onClick={() => setFilter('all')}>Все</button>
                        <button type='button' aria-pressed={filter === 'in_progress'} className={filter === 'in_progress' ? 'is-active' : ''} onClick={() => setFilter('in_progress')}>В процессе</button>
                        <button type='button' aria-pressed={filter === 'passed'} className={filter === 'passed' ? 'is-active' : ''} onClick={() => setFilter('passed')}>Пройдено</button>
                    </div>
                    <section className='learning-section'>
                        <h3>{filter === 'all' ? 'Все уроки' : filter === 'passed' ? 'Пройденные тесты' : 'Продолжить обучение'}</h3>
                        {visibleLessons.length > 0 ? visibleLessons.map(lesson => <LessonCard key={lesson.id} lesson={lesson}/>)
                            : <div className='learning-empty'>Уроков с таким статусом пока нет.</div>}
                    </section>
                </>}
            </div>
        </div>
        <Menu/>
    </div>;
}

export default KnowledgeBase1;
